import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const FolderOpenIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "FolderOpen",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M5.19 26.87c.21.62.79 1.06 1.47 1.06h19.71c2 0 3.63-1.62 3.63-3.63V13.9c0-2-1.63-3.62-3.63-3.62h-7.84a.52.52 0 0 1-.49-.35s-1.13-3.39-1.13-3.39c-.5-1.45-1.85-2.48-3.44-2.48h-3.23c-1.59 0-2.95 1.03-3.44 2.45v.03l-1.5 4.49c-.12.34-.19.73-.19 1.14v1.23H22.7c.46 0 .84.3.98.71s.48 1.44.48 1.44l1.26 3.79 1.41 4.1a1.04 1.04 0 0 1-.99 1.36h-.12c-.4-.06-.72-.34-.84-.71s-.83-2.52-.83-2.52l-2.04-6.11H3.55c-.86 0-1.56.7-1.56 1.56q0 .27.09.51s3.11 9.33 3.11 9.33Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.43 29.28H6.96c-1.55 0-2.91-1.04-3.31-2.54L-.02 13.03c-.28-1.04-.06-2.12.59-2.97a3.41 3.41 0 0 1 2.72-1.34H7.5V5.29c0-1.89 1.54-3.43 3.43-3.43h6.27c.92 0 1.78.36 2.42 1l.95.95c.21.21.51.33.81.33h7.05c1.89 0 3.43 1.54 3.43 3.43v18.28c0 1.89-1.54 3.43-3.43 3.43M3.29 11c-.36 0-.69.16-.91.45-.22.28-.29.64-.2.99l3.67 13.71c.13.5.59.85 1.1.85h21.47c.63 0 1.14-.51 1.14-1.14V7.57c0-.63-.51-1.14-1.14-1.14h-7.05c-.9 0-1.79-.37-2.42-1L18 4.48c-.22-.22-.5-.33-.81-.33h-6.27c-.63 0-1.14.51-1.14 1.14v3.43h10.57c1.55 0 2.91 1.04 3.31 2.54l3.22 12.03c.16.61-.2 1.24-.81 1.4s-1.24-.2-1.4-.81l-3.22-12.03c-.13-.5-.59-.85-1.1-.85H3.29"
      })
    })
  }));
};